const initialState = {
    list: {},
    error: {}
};

const ChildPropertiesReducer = (state, action) => {
    if (state === null || state === undefined) {
        state = initialState;
    }
    switch (action.type) {
        case "GET_CHILD_PROPERTIES_SUCCESS":
            state = {
                ...state,
                list: action.payload
            };

            return state;
        case "GET_CHILD_PROPERTIES_ERROR":
            state = {
                ...state,
                error: action.payload
            };
            return state;
        default:
            return state;
    }
};

export default ChildPropertiesReducer;

